import React, {useState} from 'react';

import MaterialTable from "material-table";
import { TableIcons } from './Icons';

import { CircleSpinnerOverlay  } from 'react-spinner-overlay'
import { Alert } from '@mui/material';

    const MonitoringPage = (props:any) => {
        const list = props.list
        const columns = props.columns
        const status = props.status
        const message = props.message
        const tableName = props.tableName
        const tableMessage = props.tableMessage
        const isLoading = props.isLoading
        const statusAlert = props.statusAlert
        const setStatusAlert = props.setStatusAlert

    return (
        <React.Fragment>   
            {isLoading
            ? <CircleSpinnerOverlay zIndex={2000} loading={isLoading}　color="#00FFFF" />
            : <></>
            }    
            <div className="row">
                <div className="col-12">
                    {tableMessage}
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    {
                        statusAlert == 1 ? 
                        <>
                        <Alert severity={status} onClose={() => { setStatusAlert(0) }}>{message}</Alert>
                        </> : <> </> 
                    }
                    <br></br>
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{tableName}</h3>
                        </div>
                        <div className="card-body">

                            <MaterialTable
                                title=""
                                icons={TableIcons}
                                columns={columns}
                                data={list}
                                options={{
                                    sorting:true,
                                    filtering: true,
                                    selection: false,
                                    emptyRowsWhenPaging: false,
                                    pageSize: 25,
                                    pageSizeOptions: [5, 10, 25, 50],
                                    loadingType: 'overlay',
                                    headerStyle: {
                                        fontWeight: 'bold',
                                    },
                                    rowStyle: rowData => ({
                                        backgroundColor: "#FFF",
                                        // backgroundColor: rowData.tableData.id % 2 === 0 ? "#EEE" : "#FFF",
                                    }),

                                }}
                                
                            />
                        </div>
                    </div>
                </div>
            </div>
              
            
            
        </React.Fragment>
    );
}

export default MonitoringPage;